<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-9">                
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn js-active position-relative" type="button">                                                
                                                <span>{{ $t('settings.New_breed') }}</span>                                                
                                            </button>                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                        <div class="bg-white">    
                                            <div class="row mt-4">                                                
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Code') }} *</label>
                                                    <input v-model="state.code" type="text" class="form-control form-control-default" :placeholder="$t('settings.Code')">
                                                    <span v-if="v$.code.$error" class="text-sm text-danger">
                                                        {{ v$.code.$errors[0].$message }}
                                                    </span>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Name') }} *</label>
                                                    <input v-model="state.name" type="text" class="form-control form-control-default" :placeholder="$t('settings.Name')">
                                                    <span v-if="v$.name.$error" class="text-sm text-danger">
                                                        {{ v$.name.$errors[0].$message }}
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-4">       
                                                <div class="col-6" v-if="['Admin'].includes(userRoleName)">
                                                    <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.Association') }} *</label>  
                                                    <select id="associationId" v-model="state.associationId" class="form-control form-control-default">
                                                        <option value="">{{ $t('settings.Select_association') }}</option>         
                                                        <option v-for="association in state.associations" :key="association.id" :value="association.id">                  
                                                            {{ association.abbreviation }}
                                                        </option>                  
                                                    </select>        
                                                    <span v-if="v$.associationId.$error" class="text-sm text-danger">
                                                        {{ v$.associationId.$errors[0].$message }}
                                                    </span>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="input-group input-group-static null">
                                                        <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.RVO_recognized') }}</label>
                                                        <div class="d-block mt-1">
                                                        <material-switch v-model="state.rvoRecognized" id="rvoRecognized" name="rvoRecognized" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-12 mt-4">
                                            <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
                                            <button v-on:click="saveForm" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Save') }}</button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import * as Choices from "choices.js";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import useVuelidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import { useStore } from 'vuex'

    export default {
        name: 'Breed_create_page',

        setup() {

            const { t } = useI18n()
            const store = useStore()

            const state = reactive ({
                name: '',
                code: '',
                associationId: '',
                rvoRecognized: false,
                associations:[],
            })

            const userRoleName = computed(() => store.state.user?.roleName)
        
            const rules = computed(() => {
                const isAdmin = userRoleName.value === 'Admin';

                return {
                    name: { required: helpers.withMessage(t('common.Required'), required) },
                    code: { required: helpers.withMessage(t('common.Required'), required) },
                    associationId: isAdmin
                    ? {
                        required: helpers.withMessage(t('common.Required'), required),
                        isSelected: helpers.withMessage(t('common.Select_an_association'), value => value !== '')
                    }
                    : {}
                }
            })
        
            const v$ = useVuelidate(rules, state)

            return {
                state,
                v$,
                userRoleName,
                choicesInstance: null
            }
        },    
    components: {
        MaterialSwitch
    },    
    async mounted() {
        if (this.userRoleName === 'Admin') {
            await this.fetchAllAssociationData();
        }
    },
    methods: {  
        async fetchAllAssociationData() {
            try {
                this.$store.commit('setShowLoading', true);

                const response = await axios.get("Association/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data.associationList)) {
                    this.state.associations = result.data.associationList;

                    this.$nextTick(() => {
                        this.initializeChoices();
                    });                    
                } else {
                    this.$showError('errors.Error_fetching_association');                    
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },      
        initializeChoices() {
            const element = document.getElementById("associationId");
            if (this.choicesInstance) {
                this.choicesInstance.destroy(); // Clean up previous instance
            }

            this.choicesInstance = new Choices(element, {
                searchEnabled: true,
                shouldSort: false,
                placeholder: true, 
                //placeholderValue: '-- Select association --', 
            });

            // Set the dropdown options
            if (Array.isArray(this.state.associations) && this.state.associations.length > 0) {
                // Check if the registerId exists among the registers
                if (this.state.associationId) {
                    const optionExists = this.state.associations.some(x => x.id === this.state.associationId);
                    if (optionExists) {
                        this.choicesInstance.setChoiceByValue([this.state.associationId]); // Set the selected value
                    } else {
                        this.choicesInstance.setChoiceByValue(''); // Clear if no match found
                    }
                }
            }

            // Listen for changes and update state
            element.addEventListener('change', (event) => {
                this.state.associationId = event.target.value; // Update the state
                this.v$.$validate(); // Trigger validation
            });
        },
        async saveForm() {
            this.submitForm();
        },           
        async submitForm() {
            try {
                const isValid = await this.v$.$validate();

                if (!isValid) {
                    //console.log('Validation failed');
                    return;
                } 
                
                this.$store.commit('setShowLoading', true);

                const formData = {
                    name: this.state.name,
                    code: this.state.code,
                    associationId: this.userRoleName === 'Admin'
                        ? this.state.associationId
                        : this.$store.state.associationAdminAssociationId,
                    rvoRecognized: this.state.rvoRecognized
                };

                const response = await axios.post('Breed/save', formData);
                this.gets = response.data;

                if (this.gets.success) {
                    this.$showSuccess('errors.Success_new_breed_added_successfully');
                    
                    this.$router.push('/settings');
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            }
            catch(e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }
    }
}
</script>
<style scoped>  
    .multisteps-form__progress-btn.js-active span {
        color: #fff !important;  
    }
</style>